module.exports = __webpack_public_path__ + "static/paradise-f968e45cae47a12f3193b789a6bd7bfa.png";